<template>
        <full-screen-dialog
            :header-back-button-disabled="true"
            header-close-button-disabled
            class="partner-test"
        >
        <div>
            <AccessToken 
                :client="client"
                :agent="agent"
                :states="luStates"
                :accessResponse="accessCodeResponse"
                @authenticate="authenticate"
                @opt-in="optIn"
            />
            <PropertyInformation 
                :property="property"
                :states="luStates"
            />
            <PrimarySellerInformation 
                :primary="primary"
            />
            <SecondarySellerInformation 
                :secondary="secondary"
            />
            <b-button block class="gold-button justify-content-center" @click="showModal" :disabled="!accessCodeResponse">Show Modal</b-button>
            <b-modal id="iframe-test" title="IFrame Test" hide-footer hide-header size="xl" class="100vh w-100">
                <iframe 
                    id="sellersshield"
                    :src="iFrameUrl"
                    class="100vh w-100"
                    style="height: 100vh;"
                    allowfullscreen
                    mozallowfullscreen
                    webkitallowfullscreen
                    oallowfullscreen
                    msallowfullscreen
                />
            </b-modal>
        </div>
        <!-- <div style="height: 100vh">
            <b-row style="height: 100vh">
                <b-col cols="3" class="scroll">
                    <b-row>
                        <b-col>
                            <h3>Client Authentication</h3>
                            <hr />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <b-form-group>
                                <label>Client ID</label>
                                <b-form-input v-model="clientId"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group>
                                <label>Client Secret</label>
                                <b-form-input v-model="clientSecret"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" class="d-flex justify-content-center align-self-center">
                            <b-form-group>
                                <b-button @click="authenticate">Authenticate IFrame</b-button>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h3>Agent Information</h3>
                            <hr />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <b-form-group>
                                <label>Agent Email</label>
                                <b-form-input v-model="agent.email"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group>
                                <label>Agent First Name</label>
                                <b-form-input v-model="agent.firstName"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group>
                                <label>Agent Last Name</label>
                                <b-form-input v-model="agent.lastName"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group>
                                <label>Agent Phone</label>
                                <b-form-input v-model="agent.phone"></b-form-input>
                            </b-form-group>
                        </b-col>                        
                        <b-col cols="12">
                            <b-form-group>
                                <label>Agent License ID</label>
                                <b-form-input v-model="agent.licenseId"></b-form-input>
                            </b-form-group>
                        </b-col>                        
                        <b-col cols="12">
                            <b-form-group>
                                <label>Agent License State</label>
                                <b-form-input v-model="agent.licenseState"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h3>Property Information</h3>
                            <hr />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <b-form-group>
                                <label>Street Address</label>
                                <b-form-input v-model="propertyAddress"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group>
                                <label>City</label>
                                <b-form-input v-model="propertyCity"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group>
                                <label>State</label>
                                <b-form-input v-model="propertyState"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group>
                                <label>Zip</label>
                                <b-form-input v-model="propertyZip"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <h3>Primary Seller Information</h3>
                            <hr />
                        </b-col>                        
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <b-form-group>
                                <label>Primary Seller Email</label>
                                <b-form-input v-model="primary.email"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group>
                                <label>Primary Seller First Name</label>
                                <b-form-input v-model="primary.firstName"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group>
                                <label>Primary Seller Last Name</label>
                                <b-form-input v-model="primary.lastName"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group>
                                <label>Primary Seller Phone</label>
                                <b-form-input v-model="primary.phone"></b-form-input>
                            </b-form-group>
                        </b-col>   
                    </b-row>
                    <b-row>
                        <b-col>
                            <h3>Secondary Seller Information</h3>
                            <hr />
                        </b-col>                        
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <b-form-group>
                                <label>Secondary Seller Email</label>
                                <b-form-input v-model="secondary.email"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group>
                                <label>Secondary Seller First Name</label>
                                <b-form-input v-model="secondary.firstName"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group>
                                <label>Secondary Seller Last Name</label>
                                <b-form-input v-model="secondary.lastName"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group>
                                <label>Secondary Seller Phone</label>
                                <b-form-input v-model="secondary.phone"></b-form-input>
                            </b-form-group>
                        </b-col>   
                    </b-row>                    
                    <b-col cols="12" class="d-flex justify-content-center align-self-center">
                            <b-form-group>
                                <b-button @click="updateInformation">Update Information</b-button>
                            </b-form-group>
                        </b-col>
                </b-col>
                <b-col cols="9">
                    <iframe 
                        id="sellersshield"
                        :src="iFrameUrl"
                        class="h-100 w-100"
                        allowfullscreen
                        mozallowfullscreen
                        webkitallowfullscreen
                        oallowfullscreen
                        msallowfullscreen
                    />
                </b-col>
            </b-row>
        </div> -->
        </full-screen-dialog>
</template>
<script>
import './PartnerTest.scss';
import FrontEndApiService from "@services/frontend.api.service";
import AccessToken from './Steps/AccessToken.vue';
import PropertyInformation from './Steps/PropertyInformation.vue';
import PrimarySellerInformation from './Steps/PrimarySellerInformation.vue';
import SecondarySellerInformation from './Steps/SecondarySellerInformation.vue';
import {runAsPublic} from "@helpers/api-helper";
import {fetchEnabledStates, getV2States} from '@helpers/state';

export default {
    name: 'PartnerTest',
    components:{
        AccessToken,
        PropertyInformation,
        PrimarySellerInformation,
        SecondarySellerInformation
    },
    data:()=>({
        client:{
            uuid: "35e579bf-3420-4619-8129-89567d52c509",
            secret: "nTPzISJJnV9Ouplw5uq09D9S"
        },
        property:{
            address: '123 TEST',
            state: 'TX',
            zip: 'TEST',
            city: 'TEST',
            developerListingId: 'TEST12345',
            referringPlatform: 'skyslope'
        },
        agent:{
            email: 'jeremy.foster@sellersshield.com',
            phone: null,
            firstName: 'Jeremy',
            lastName: 'Foster',
            licenseId: 'TX12345',
            licenseState: 'TX',
            broker: null,
            referring: null
        },
        primary:{
            email: null,
            firstName: null,
            lastName: null,
            phone: null
        },
        secondary:{
            email: null,
            firstName: null,
            lastName: null,
            phone: null
        },
        steps:[
            'AccessCode',
            'BrokerInformation',
            'PropertyInformation',
            'PrimarySellerInformation',
            'SecondarySellerInformation'
        ],
        currentStep: 'AccessCode',
        luStates: [],
        accessCodeResponse: null
    }),
    methods:{
        async authenticate(){
            let resp = await FrontEndApiService.post(window.env.APP_URL+`/auth/partnerAccessToken`, {
                client_id: this.client.uuid,
                client_secret: this.client.secret,
                agentEmail: this.agent.email,
                agentFirstName: this.agent.firstName,
                agentLastName: this.agent.lastName,
                agentLicenseId: this.agent.licenseId,
                agentLicenseState: this.agent.licenseState,
                broker: this.agent.broker
            });
            this.accessCodeResponse = resp.data;
        },
        async optIn(){
            let resp = await FrontEndApiService.post(window.env.APP_URL+'/auth/partnerOptIn',{
                client_id: this.client.uuid,
                agentEmail: this.agent.email,
                agentFirstName: this.agent.firstName,
                agentLastName: this.agent.lastName,
                agentLicenseId: this.agent.licenseId,
                agentLicenseState: this.agent.licenseState,
                referringSource: this.agent.referring
            });
        },
        async updateInformation(){
            let iframe = window.document.getElementById('sellersshield');
            await iframe.contentWindow.postMessage({
                action: 'pre_fill',
                propertyAddress: this.property.address,
                propertyCity: this.property.city,
                propertyState: this.property.state,
                propertyZip: this.property.zip,
                agentEmail: this.agent.email,
                agentFirstName: this.agent.firstName,
                agentLastName: this.agent.lastName,
                agentLicenseId: this.agent.licenseId,
                agentLicenseState: this.agent.licenseState,
                primarySellerEmailAddress: this.primary.email,
                primarySellerFirstName: this.primary.firstName,
                primarySellerLastName: this.primary.lastName,
                primarySellerPhone: this.primary.phone,
                secondarySellerEmailAddress: this.secondary.email,
                secondarySellerFirstName: this.secondary.firstName,
                secondarySellerLastName: this.secondary.lastName,
                secondarySellerPhone: this.secondary.phone,
                developerListingId: this.property.developerListingId,
                referringPlatform: this.property.referringPlatform
            }, '*');
        },
        async showModal(){
            this.$bvModal.show('iframe-test');
            
        }
    },
    computed:{
        iFrameUrl(){
            return window.env.APP_URL+"/partner/skyslopeInvitation"
        },
        accessTokenUrl(){
            return window.env.APP_URL+`/auth/partnerAccessToken`;
        }
    },
    async mounted(){
        runAsPublic(async ()=>{
            let states = await fetchEnabledStates();
            this.luStates = states.toArray().map(f=>({
                text: f.title, 
                value: f.slug.toUpperCase()
            }));
        });
        window.onmessage = async (event) => {
            if(event.data && event.data.action === 'loaded'){
                let iframe = window.document.getElementById('sellersshield');
                await iframe.contentWindow.postMessage({
                    action: 'access_code',
                    accessToken: this.accessCodeResponse.token
                }, '*');
                
            }else if(event.data && event.data.action === 'authenticated'){
                await this.updateInformation();
            }else if(event.data && event.data.action === 'invitation_submitted'){
                console.log(event.data);
            }else if(event.data && event.data.action === 'error_submitting_invitation'){
                console.log(event.data);
            }       
        }
    }
}
</script>
